// extracted by mini-css-extract-plugin
export default {"dropDownGradient":"SignInButton_dropDownGradient__DVnbl","loginIcon":"SignInButton_loginIcon__171gv"};